import { render, staticRenderFns } from "./tpl-6.vue?vue&type=template&id=7354474d&scoped=true"
import script from "./tpl-6.vue?vue&type=script&lang=js"
export * from "./tpl-6.vue?vue&type=script&lang=js"
import style0 from "./tpl-6.vue?vue&type=style&index=0&id=7354474d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7354474d",
  null
  
)

export default component.exports